export default "__VITE_ASSET__65b92b68__"